import React, { type PropsWithChildren } from 'react';
import { LinearGradient } from 'expo-linear-gradient';
import { type ColorValue, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuDietaryPreferencesFooter = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <View style={styles.footer}>
      <LinearGradient colors={GRADIENT_COLORS} style={styles.gradient} pointerEvents="none" />

      {children}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GRADIENT_COLORS: [ColorValue, ColorValue] = [
  theme.colors.OPACITY.CREAM.TRANSPARENT,
  theme.colors.APP_BACKGROUND,
];
const GRADIENT_HEIGHT = theme.spacing['8'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['8'],
  },
  gradient: {
    position: 'absolute',
    right: 0,
    top: -GRADIENT_HEIGHT,
    left: 0,
    height: GRADIENT_HEIGHT,
  },
});
